import { render, staticRenderFns } from "./SingleReturnPartners.vue?vue&type=template&id=e41f194e&scoped=true&"
import script from "./SingleReturnPartners.vue?vue&type=script&lang=js&"
export * from "./SingleReturnPartners.vue?vue&type=script&lang=js&"
import style0 from "./SingleReturnPartners.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleReturnPartners.vue?vue&type=style&index=1&id=e41f194e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41f194e",
  null
  
)

component.options.__file = "SingleReturnPartners.vue"
export default component.exports